import * as Yup from 'yup'

/*
  Configuração do sinal do agendamento online, na aba Config → Agenda.

  As regras só valem com o sinal ligado: um salão que deixou a funcionalidade desligada não
  precisa ter escolhido percentual nem meio de pagamento para conseguir salvar.
*/
const onlinePaymentConfigValidator = Yup.object ().shape ({
  enabled: Yup.boolean (),

  depositPercentage: Yup.number ()
    .when ('enabled', {
      is: true,
      then: schema => schema
        .required ('Informe o percentual do sinal')
        .min (1, 'O sinal deve ser de pelo menos 1%')
        /*
          100% é sinal do serviço inteiro, e é uma escolha legítima. Acima disso o salão
          estaria cobrando adiantado mais do que o serviço custa.
        */
        .max (100, 'O sinal não pode passar de 100%')
    }),

  methods: Yup.array ()
    .when ('enabled', {
      is: true,
      then: schema => schema.min (1, 'Escolha pelo menos uma forma de pagamento')
    })
})

export default onlinePaymentConfigValidator
